/**
 * Hover swap of a field details metric (e.g. Kc → Kc optimized), used by the
 * Farm View "Field details" strip. Pure so it can be unit tested without
 * React.
 */

// The strip swaps only when the hover is allowed for this user AND there is
// something to show; an empty optimized value would leave a blank cell.
const canSwapOnHover = ({ hoverCondition, onHover }) =>
  Boolean(hoverCondition) &&
  onHover !== '' &&
  onHover !== null &&
  onHover !== undefined;

module.exports = { canSwapOnHover };
